import * as React from 'react';
import { FC, useState } from 'react';
import { Prize } from './types';
import InfoIcon from './images/info';
import { useLocales } from './locales';
import { Popup } from './Popup';

const Prizes: FC<{ prizes: Prize[] }> = ({ prizes }) => {
  const [popupInfos, setPopupInfos] = useState<{ visible: boolean; text: string; prize: string }>({
    visible: false,
    text: '',
    prize: '',
  });
  const l = useLocales();
  const sectionLabelId = 'available-prizes-label';

  const changePopupText = (prize: Prize) => {
    setPopupInfos({ visible: true, text: prize.description, prize: prize.name });
  };

  const resetPopup = () => {
    setPopupInfos({ visible: false, text: '', prize: '' });
  };

  return (
    <div className="prizes" aria-labelledby={sectionLabelId}>
      <h3 className="prizes_title" id={sectionLabelId}>
        {l('available_prizes')}
      </h3>
      <ul className="prizes_list">
        {prizes.map((prize) => (
          <li className="prizes_item p-i" key={prize.id}>
            <div className="p-i_image">
              <img src={prize.image.file_url || ''} alt={prize.image.file_name || ''} />
            </div>
            <div className="p-i_quantity" aria-label="prize quantity">
              {prize.quantity}
            </div>
            <div className="p-i_name" aria-label="prize name">
              {prize.name}
            </div>
            <div className="p-i_info">
              {prize.description.length >= 15 ? (
                <button
                  className="p-i_info-button"
                  onClick={() => changePopupText(prize)}
                  aria-label="prize info"
                  type="button"
                >
                  <InfoIcon />
                </button>
              ) : null}
            </div>
          </li>
        ))}
      </ul>
      <Popup
        type="info"
        title={`${l('use_prize')} ${popupInfos.prize}`}
        visible={popupInfos.visible}
        render={() => (
          <>
            {/* eslint-disable-next-line react/no-danger */}
            <div
              className="td-popup_content"
              aria-label="get ticket info"
              dangerouslySetInnerHTML={{ __html: popupInfos.text }}
            />
          </>
        )}
        reset={resetPopup}
      />
    </div>
  );
};

export default Prizes;
